import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { FiChevronDown } from 'react-icons/fi'
import { device } from '../Breakpoints'
import primarioMetadata from '../../hooks/QueryMenuPrimario'
import iconQuemSomos from '../../icons/icon-info.svg'
import iconFaleConosco from '../../icons/icon-chat.svg'
import iconPlanosEConvenios from '../../icons/icon-planoseconvenios.svg'
import iconOndeEstamos from '../../icons/icon-pin.svg'
import iconAgendar from '../../icons/agendar.svg'

const Container = styled.nav`
  background: #e8f2ed;
  flex-grow: 1;
  display: flex;
  padding-left: 1.5em;
  @media ${device.laptopL} {
    padding-left: 0em;
  }
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    li {
      margin: 0;
      padding: 0;
      list-style: none;
      height: 100%;
      align-items: center;
      display: flex;
      position: relative;
      :hover {
        background: #fff;
        > .submenu {
          display: block;
        }
      }
      a {
        align-items: center;
        display: flex;
        height: 85px;
        padding-left: 50px;
        font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
        font-size: 0.8em;
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /**
      Target IE11
      */
          font-weight: bold !important;
          background-size: 25px !important;
        }
      }
      :last-child {
        a {
          padding-left: 50px;
        }
      }
      .item-10118 {
        background: url(${iconQuemSomos}) no-repeat 15px center;
      }
      .item-9536 {
        background: url(${iconOndeEstamos}) no-repeat 15px center;
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /**
      Target IE11
      */
          background-size: 20px !important;
        }
      }
      .item-9535 {
        background: url(${iconFaleConosco}) no-repeat 15px center;
      }
      .item-11175 {
        background: url(${iconAgendar}) no-repeat 15px center;
        background-size: 25px;
      }
      .item-9942 {
        background: url(${iconPlanosEConvenios}) no-repeat 15px center;
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /**
      Target IE11
      */
          background-size: 23px !important;
        }
      }
    }
  }

  .submenu {
    display: none;
    position: absolute;
    left: 0;
    top: 58px;
    width: 100%;
    background: #fff;
    padding: 1em;
    max-width: 100%;
    box-sizing: border-box;
    z-index: 4;
    a {
      padding: 1em !important;
      display: block;
      font-size: 0.8em;
      height: 100%;
      width: 100%;
      :hover {
        background: #e8f2ed;
      }
    }
  }
  a {
    padding: 0 30px;
    color: #148581;
    text-decoration: none;
    font-family: 'Santral', Arial, Helvetica, sans-serif;
    text-transform: uppercase;
    font-size: 0.8em;

    @media ${device.laptop} {
      padding: 0 10px;
      margin-left: 10px;
    }
    @media ${device.laptopL} {
      padding: 0 10px;
    }
    img {
      vertical-align: middle;
      margin-right: 10px;
    }
    svg {
      vertical-align: middle;
      margin-left: 10px;
    }
  }
`

const MenuPrimario = () => {
  const primario = primarioMetadata()
  const data = primario[0].node.menuItems.nodes.filter(item => {
    return item.parentDatabaseId === 0
  })
  return (
    <Container>
      <ul className="menu">
        {data.map(item => (
          <li key={item.order}>
            {item.connectedNode === null ? (
              <a
                href={item.url}
                target="_blank"
                rel="noreferrer"
                className={`item-${item.databaseId}`}
              >
                {item.label}
              </a>
            ) : (
              <Link
                to={item.url}
                className={`item-${item.databaseId}`}
                state={{ area: item.label }}
              >
                {item.label}
                {item.childItems.nodes.length !== 0 ? (
                  <FiChevronDown size="1.5em" />
                ) : (
                  ''
                )}
              </Link>
            )}
            {item.childItems.nodes.length !== 0 ? (
              <ul className="submenu">
                {item.childItems.nodes.map(child => (
                  <li key={child.order}>
                    <Link to={child.url} state={{ area: item.label }}>
                      {child.label}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              ''
            )}
          </li>
        ))}
      </ul>
    </Container>
  )
}

export default MenuPrimario
